import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    FormLabel,
    IconButton,
    InputAdornment,
    Stack,
    styled,
    TextField
} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import {useState} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import {LoginService} from "../service/auth";
import {SetItem} from "../utils/storage";
import {StorageKey} from "../constants/constants";
import {VisibilityOffRounded, VisibilityRounded} from "@mui/icons-material";
import { jwtDecode } from "jwt-decode";
import OtpForm from "../pages/OtpForm"
import AuthLayout from "../layouts/AuthLayout";


export default function Login() {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [error, setError] = useState(null);
    const [showOtpForm, setShowOtpForm] = useState(false); 
    const [otpData, setOtpData] = useState(null); 

    const formik = useFormik({
        initialValues: { username: '', password: '' },
        validationSchema: Yup.object().shape({
            username: Yup.string().email('Invalid email').required('Required'),
            password: Yup.string().required("Please enter a password"),
        }),
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: values => handleSubmit(values)
    });
    // console.log(formik.values)
    const handleSubmit = async (values) => {
        setLoadingSubmit(true);
        
        return LoginService(values).then(async (res) => {
            if (res.status === 200) {
                const token = res.data.access_token;
                const decoded = jwtDecode(token);
                const { sub: id, email, name: fullname, metadata, otp } = decoded;
                await SetItem(StorageKey.TOKEN, token);
                await SetItem(
                    StorageKey.USER,
                    JSON.stringify({ id, email, fullname, metadata, otp })
                );
                setOtpData({ id, email, fullname, metadata, otp });
                setShowOtpForm(true);
            } else {
                setError("Credenciales no validas!!");
            }
            setLoadingSubmit(false);
        })
        .catch((err) => {
      
            if (err.response?.data) {
                setError(err.response?.data.details ? err.response?.data.details :"Ocurrio un error!!");
                setLoadingSubmit(false);
            }
        });

    };

    if (showOtpForm && otpData) {
        // Si se debe mostrar el formulario OTP, renderiza el componente OtpForm
        return <OtpForm otpData={otpData} />;
    }

    return (
        <Box>
            <Card sx={{
                width: { xs: '90%', md: '60%', lg: '30%', xl: '25%' },
                margin: 'auto',
                position: 'relative',
                zIndex: 1
            }}>
                <CardContent>
                    <form onSubmit={formik.handleSubmit}>
                        <Stack justifyContent="center" alignItems="center" spacing={3} sx={{ minHeight: '100%' }}>
                            <Link to="/">
                                <img src="/images/logo/logo.webp" alt="logo" style={{ width: '100%', height: '100%' }}/>
                            </Link>
                            {error && (
                                <>
                                    <Alert severity="error">{error}</Alert>
                                </>
                            )}
                            <Box sx={{ width: '100%' }}>
                                <FormLabel>Correo</FormLabel>
                                <TextField
                                    fullWidth
                                    // name="email"
                                    onChange={(e) => formik.setFieldValue('username', e.target.value)}
                                    // error={Boolean(formik.errors.email)}
                                    // helperText={formik.errors.email}
                                    // value={formik.values.email}
                                    type="email"/>
                            </Box>
                            <Box sx={{ width: '100%' }}>
                                <FormLabel>Contraseña</FormLabel>
                                <TextField
                                    fullWidth
                                    name="password"
                                    error={Boolean(formik.errors.password)}
                                    helperText={formik.errors.password}
                                    type={showPassword ? 'text' : 'password'}
                                    onChange={formik.handleChange}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)}>
                                                {showPassword ? <VisibilityRounded fontSize="small"/> : <VisibilityOffRounded fontSize="small"/>}
                                            </IconButton>
                                        </InputAdornment>
                                    }}/>
                            </Box>
                            <Button
                                fullWidth
                                disableElevation
                                disabled={loadingSubmit}
                                color="primary"
                                variant="contained"
                                type="submit">
                                Login
                            </Button>
                        </Stack>
                    </form>
                </CardContent>
            </Card>
        </Box>
    )
}